export default __webpack_public_path__ + "static/media/v2.d88d4a09.jpg";